import { configureStore } from "@reduxjs/toolkit";
import uiSlice from "./ui-slice";
import authSlice from "./auth-slice";
import themeSlice from "./theme-slice";

const store = configureStore({
  reducer: {
    auth: authSlice,
    theme: themeSlice,
    ui: uiSlice,
  },
});

export default store;
